import client from './client';
import type { Scene } from '@dtwin/shared';

export async function fetchScenes(): Promise<Scene[]> {
  const { data } = await client.get('/scenes');
  return data;
}

export async function fetchScene(id: string): Promise<Scene> {
  const { data } = await client.get(`/scenes/${id}`);
  return data;
}

export async function createScene(body: { name: string; description?: string }): Promise<Scene> {
  const { data } = await client.post('/scenes', body);
  return data;
}

export async function updateScene(id: string, body: Partial<Scene>): Promise<Scene> {
  const { data } = await client.put(`/scenes/${id}`, body);
  return data;
}

export async function deleteScene(id: string): Promise<void> {
  await client.delete(`/scenes/${id}`);
}

export async function fetchTrashScenes(): Promise<any[]> {
  const { data } = await client.get('/scenes/trash');
  return data;
}

export async function restoreScene(id: string): Promise<any> {
  const { data } = await client.post(`/scenes/${id}/restore`);
  return data;
}

export async function permanentDeleteScene(id: string): Promise<void> {
  await client.delete(`/scenes/${id}/permanent`);
}

export async function publishScene(id: string): Promise<Scene> {
  const { data } = await client.post(`/scenes/${id}/publish`);
  return data;
}

export async function unpublishScene(id: string): Promise<Scene> {
  const { data } = await client.post(`/scenes/${id}/unpublish`);
  return data;
}
